// modal/detail/panels/IncomeKpiPanel.jsx
import React from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import { StatCard } from 'shared/ui/soft/StatCard';
import { PillIcon } from 'shared/ui/soft/PillIcon';

import { moneyTry } from '../../../utils/staffFormatters';
import { SoftCard } from 'shared/ui/soft/SoftCard';

export function IncomeKpiPanel({ active, metrics }) {
  if (!active) return <div style={{ display: 'none' }} />;

  return (
    <MDBox sx={{ display: 'grid', gap: 1.25 }}>
      <MDBox
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: 1.25,
        }}
      >
        <StatCard
          tone="amber"
          icon="payments"
          label="Kazanç"
          value={moneyTry(metrics.weeklyRevenue)}
          hint="50000 kırmızı"
          valueTone="bad"
        />
        <StatCard
          tone="teal"
          icon="savings"
          label="Diğer"
          value={moneyTry(metrics.weeklyCost)}
          hint="27000 yeşil"
          valueTone="good"
        />
        <StatCard
          tone="violet"
          icon="settings_suggest"
          label="Ücret Modeli"
          value={metrics.wagePreview}
          hint="Saatlik / yüzdeli / maaş"
        />
      </MDBox>

      <SoftCard>
        <MDBox display="flex" alignItems="center" gap={1} sx={{ mb: 1 }}>
          <PillIcon icon="analytics" tone="blue" />
          <MDBox>
            <MDTypography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.1 }}>
              Detaylı KPI (mock)
            </MDTypography>
            <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
              Sonraki adım: grafikler, tarih aralığı filtreleri
            </MDTypography>
          </MDBox>
        </MDBox>

        <MDBox sx={{ display: 'grid', gap: 0.8 }}>
          <MDTypography variant="button">
            • Üye başı gelir:{' '}
            <b>₺{Math.round((metrics.weeklyRevenue || 0) / Math.max(1, metrics.memberCount))}</b>
          </MDTypography>
          <MDTypography variant="button">
            • Seans başı gelir: <b>₺480</b>
          </MDTypography>
          <MDTypography variant="button">
            • İptal oranı: <b>%3</b>
          </MDTypography>
        </MDBox>
      </SoftCard>
    </MDBox>
  );
}
